import { render, staticRenderFns } from "./AAsignarCargo.vue?vue&type=template&id=5de15dfc"
import script from "./AAsignarCargo.vue?vue&type=script&lang=js"
export * from "./AAsignarCargo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports